// extracted by mini-css-extract-plugin
export var sliderRange = "_p0-2";
export var sliderRoot = "_p0-0";
export var sliderThumb = "_p0-3";
export var sliderTrack = "_p0-1";